<template>
   <div class="products">
     <Hero :backImg="require('../assets/img/product/hero.jpg')" :backImgSp="require('../assets/img/product/hero_sp.jpg')" alt="" title="事業と製品紹介" text="クレハは自社開発のDNAを何よりも大切にしています。<br>1944年の創立以来、外部技術の導入に頼ることなく独自の発想で商品開発を続け、<br>事業を拡大してきた技術開発型企業です。" />
    <div class="contents">
      <div class="introduction">
        クレハの根幹を担う3つのコア事業。<br>
        その全てにおいてグローバル視点に立ち、<br>
        持続的な発展を目指すことで<br>
        「エクセレント・カンパニー」を実現します。
      </div>
      <div class="banner">
        <!-- <div class="photo">
          <img src="../assets/img/product/banner.jpg" alt="">
        </div>
        <div class="">
          クレハの事業開発について、<br>
          詳しくはコチラ<KurehaArrow class="kureha_arrow" :width="300" />
        </div> -->
        <a href="https://www.kureha.co.jp/development/" target="_self">
          <picture>
            <source srcset="../assets/img/product/img/banner.jpg"
                      media="(min-width: 768px)">
            <source srcset="../assets/img/product/img/banner_sp.jpg"
                      media="(max-width: 767px)">
            <img src="../assets/img/product/img/banner.jpg" />
          </picture>
        </a>
      </div>
      <section class="business">
        <picture>
          <source srcset="../assets/img/product/img/01.jpg"
                    media="(min-width: 768px)">
          <source srcset="../assets/img/product/img/01_sp.jpg"
                    media="(max-width: 767px)">
          <img src="../assets/img/product/img/01.jpg" />
        </picture>
        <a href="https://www.kureha.co.jp/business/material/" target="_self" class="link">
          <picture>
            <source srcset="../assets/img/product/img/link.jpg"
                      media="(min-width: 768px)">
            <source srcset="../assets/img/product/img/link_sp.jpg"
                      media="(max-width: 767px)">
            <img src="../assets/img/product/img/link.jpg" />
          </picture>
        </a>
      </section>
      <section class="business">
        <picture>
          <source srcset="../assets/img/product/img/02.jpg"
                    media="(min-width: 768px)">
          <source srcset="../assets/img/product/img/02_sp.jpg"
                    media="(max-width: 767px)">
          <img src="../assets/img/product/img/02.jpg" />
        </picture>
        <a href="https://www.kureha.co.jp/business/chemical/" target="_self" class="link">
          <picture>
            <source srcset="../assets/img/product/img/link.jpg"
                      media="(min-width: 768px)">
            <source srcset="../assets/img/product/img/link_sp.jpg"
                      media="(max-width: 767px)">
            <img src="../assets/img/product/img/link.jpg" />
          </picture>
        </a>
      </section>
      <section class="business">
        <picture>
          <source srcset="../assets/img/product/img/03.jpg"
                    media="(min-width: 768px)">
          <source srcset="../assets/img/product/img/03_sp.jpg"
                    media="(max-width: 767px)">
          <img src="../assets/img/product/img/03.jpg" />
        </picture>
        <a href="https://www.kureha.co.jp/business/polymer/" target="_self" class="link">
          <picture>
            <source srcset="../assets/img/product/img/link.jpg"
                      media="(min-width: 768px)">
            <source srcset="../assets/img/product/img/link_sp.jpg"
                      media="(max-width: 767px)">
            <img src="../assets/img/product/img/link.jpg" />
          </picture>
        </a>
      </section>
    </div>
   </div>
</template>

<script>
// import KurehaArrow from "@/components/icons/KurehaArrow.vue"
import Hero from '@/components/Hero.vue';
export default {
  name: 'product',
  components: {
    // KurehaArrow,
    Hero
  }
}
</script>

<style lang="scss" scoped>
.contents {
  margin: 0 auto;
  max-width: 840px;
  width: 90%;
  padding: 100px 0 150px 0;
  @media print, screen and (max-width: 768px) {
    padding: 50px 0 100px 0;
  }
}
.introduction {
  font-size: 24px;
  font-weight: bold;
  color: #00797f;
  text-align: center;
  @media print,screen and (max-width: 768px) {
    font-size: 16px;
  }
}
.banner {
  margin-top: 100px;
}
.business {
  margin-top: 100px;
  position: relative;
  &:nth-child(even) {
    .link {
      text-align: right;
    }
  }
}
.link {
  position: relative;
  margin-top: 30px;
  display: block;
  img {
    max-width: 350px;
    width: 100%;
  }
}
</style>